import { Pressable, StyleProp, ViewStyle } from 'react-native';
import { Avatar } from 'react-native-paper';
import { Colors } from '../../themes/colors';

interface OrangeButtonProps {
  onButtonPress: () => void;
  isMenuVisible?: boolean;
  propStyle?: StyleProp<ViewStyle>;
}

export const OrangeButton = ({
  onButtonPress,
  isMenuVisible,
  propStyle,
}: OrangeButtonProps) => {
  return (
    <Pressable testID="orange-button" onPress={onButtonPress} style={propStyle}>
      <Avatar.Icon
        icon={isMenuVisible ? 'close' : 'plus'}
        color={Colors.role.textOnBrand}
        size={50}
        style={[
          {
            backgroundColor: isMenuVisible
              ? Colors.primaryDark
              : Colors.primary,
          },
        ]}
      />
    </Pressable>
  );
};

export default OrangeButton;
